import { gql } from '@apollo/client';
import { COMMUNITY_USERS_EDGES_NODE_FRAGMENT } from 'schema/User/queries';

export const SPACE_FRAGMENT = gql`
  fragment SpaceFields on CommunitySpace {
    id
    name
    description
    iconName
    position
    imageUrl
    imageAltText
    s3UploadPath
    isExclusive
    communityProductRelation {
      id
      product {
        id
      }
    }
  }
`;

export const SPACE_QUERY = gql`
  query CommunitySpace($communityId: ID!, $spaceId: ID!) {
    community(id: $communityId) {
      id
      communitySpace(id: $spaceId) {
        ...SpaceFields
        posts {
          totalCount
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
  ${SPACE_FRAGMENT}
`;

export const SPACE_INFO_QUERY = gql`
  query CommunitySpaceInfo($communityId: ID!, $spaceId: ID!) {
    community(id: $communityId) {
      id
      communitySpace(id: $spaceId) {
        ...SpaceFields
        spaceMembers(first: 5, filter: { active: true }) {
          totalCount
          edges {
            node {
              id
              user {
                id
                fullName
                profile {
                  id
                  avatarUrl
                }
              }
            }
          }
        }
      }
    }
  }
  ${SPACE_FRAGMENT}
`;

export const SPACE_MEMBERS_QUERY = gql`
  query CommunitySpaceMembers(
    $communityId: ID!
    $spaceId: ID!
    $numberOfUsers: Int = 5
    $after: String
    $searchTerm: String
  ) {
    community(id: $communityId) {
      id
      communitySpace(id: $spaceId) {
        ...SpaceFields
        spaceMembers(
          first: $numberOfUsers
          after: $after
          filter: { active: true, name: $searchTerm }
          orderBy: { field: CREATED_AT, direction: ASC }
        ) {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              ...CommunityEdgesNodeFields
            }
          }
        }
      }
    }
  }
  ${SPACE_FRAGMENT}
  ${COMMUNITY_USERS_EDGES_NODE_FRAGMENT}
`;
